// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".BindKeyboardSwipeableViews {\n  display: block;\n  width: 100vw;\n  height: 100vh;\n}\n\n.Contribution {\n  text-align: left;\n  margin: 0;\n  padding: 0;\n  width: 100vw;\n  height: 100vh;\n  display: block;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  overflow: hidden;\n}", ""]);
// Exports
module.exports = exports;
